import { createSlice } from '@reduxjs/toolkit';

import { changeCurrencyFormatCase } from './cases/changeCurrencyFormat';
import { changeThemeCase } from './cases/changeTheme';
import { loadSettingsCase } from './cases/loadSettings';
import { initialState } from './initialStates';

const slice = createSlice({
  name: 'Settings',
  initialState,
  reducers: {
    changeTheme: changeThemeCase,
    changeCurrencyFormat: changeCurrencyFormatCase,
    loadSettings: loadSettingsCase,
  },
});

const { reducer } = slice;

export const { changeTheme, changeCurrencyFormat, loadSettings } =
  slice.actions;

export default reducer;
